import { staff } from '../../data/homeData';

const StaffSection = () => (
  <section className="py-16 md:py-24 bg-slate-50" data-testid="staff-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-4">Meet Our Team</h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">Dedicated professionals committed to your care and comfort.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {staff.map((member, index) => (
          <div key={index} className="bg-gray-200 rounded-xl p-6 text-center" data-testid={`staff-card-${index}`}>
            <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden bg-gray-300">
              {member.image ? (
                <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-400 text-4xl font-heading">{member.name.charAt(0)}</div>
              )}
            </div>
            <h3 className="font-heading text-xl font-semibold text-primary mb-1">{member.name}</h3>
            <p className="text-black font-medium text-sm mb-3">{member.role}</p>
            {member.phone && (
              <a href={`tel:${member.phone.replace(/[^0-9]/g, '')}`} className="text-slate-600 text-sm block mb-3 hover:text-black">{member.phone}</a>
            )}
            <p className="text-slate-600 text-sm leading-relaxed">{member.bio}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StaffSection;
